<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 0C18.6133 0 24 5.38666 24 12C24 18.6133 18.6133 24 12 24C5.38666 24 0 18.6133 0 12C0 5.38666 5.38666 0 12 0ZM12.75 12.7074H16.95V11.2074H12.75V7.00737H11.25V11.2074H7.05V12.7074H11.25V16.9074H12.75V12.7074Z" fill="currentColor"/>
</svg>
